/* eslint-disable react/require-optimization */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { cachedEndpointsService, InvoiceEstimatesService, JobService } from '@services';
import utils from '@utils';
import { RECURRENCE_FREQUENCIES } from '@constants';
import { Loader } from '@components/common';
import appActions from '@redux/app';
import ReactGA from 'react-ga';
import PublicMenu from '../../components/PublicMenu';
import {
	ProgressBar,
	SecurityType,
	JobDateTime,
	BusinessInfo,
	ContactInfo,
	EstimatePreview,
	Confirmation,
} from './components';
import Rewind from '../../images/rewind.png';
import './MarketPlace.scss';
import '../../styles/slick/slick.scss';
import '../../styles/slick/slick-theme.scss';

class MarketPlace extends Component {
	constructor(props) {
		super(props);

		const state = {
			currentStep      : 1,
			accountCreated   : false,
			requestSubmitted : false,
			form             : {
				JobEventTypeId : 1,
				JobEventType   : 'General Security',
				business       : {
					LocationName   : '',
					LocationTypeId : '',
					StreetAddress  : '',
					City           : '',
					StateId        : '',
					ZipCode        : '',
				},
				jobDateTime : {
					StartDateTime : '',
					EndDateTime   : '',
					JobDetails    : '',
					Recurrence    : null,
				},
				contact : {
					FirstName   : '',
					LastName    : '',
					Email       : '',
					MobilePhone : '',
					Password    : '',
				},
				stateName      : '',
				repeatTypeName : '',
			},
			USStates    : [],
			estimate    : {},
			loading     : false,
			signUpToken : null,
			referrer    : '',
		};

		const { user } = props;
		this.isLoggedIn = user.Id !== null && user.Id !== undefined;
		if (this.isLoggedIn) {
			state.steps = [
				'Security Type',
				'Date',
				'Location',
				'Estimate',
			];
		} else {
			state.steps = [
				'Security Type',
				'Date',
				'Location',
				'Contact',
				'Estimate',
			];
		}

		this.state = state;

		this.slider = null;
	}

	componentDidMount() {
		const { location : { search } } = this.props;
		if (search) {
			// retrieve the value passed into the referrer url param
			const params = new URLSearchParams(search);
			const value = params.get('referrer');
			this.setState({ referrer : value });
		}
		this.getUSStates();
	}

	getUSStates = () => {
		cachedEndpointsService.getUSStates()
			.then(({ data }) => {
				const USStates = data.map(({ Id, Name }) => ({
					value : Id,
					label : Name,
				}));

				this.setState({ USStates });
			})
			.catch(() => {
				utils.notify({
					type    : 'error',
					message : 'Error loading US States',
					title   : '',
				});
			});
	}

	buildJobRequestData = (form) => {
		const { referrer } = this.state;
		const { jobDateTime : { StartDateTime, EndDateTime } } = form;

		const params = {
			JobEventTypeId : form.JobEventTypeId,
			StartDateTime  : new Date(StartDateTime.getTime() - (StartDateTime.getTimezoneOffset() * 60000)).toISOString().slice(0, -1),
			EndDateTime    : new Date(EndDateTime.getTime() - (EndDateTime.getTimezoneOffset() * 60000)).toISOString().slice(0, -1),
			JobDetails     : form.jobDateTime.JobDetails,
			LocationName   : form.business.LocationName,
			City           : form.business.City,
			StateId        : form.business.StateId,
			LocationTypeId : form.business.LocationTypeId,
			StreetAddress  : form.business.StreetAddress,
			ZipCode        : form.business.ZipCode,
			ReferredBy     : referrer || '',
		};

		if (form.jobDateTime.Recurrence) {
			const { jobDateTime : { Recurrence : { EndsOn } } } = form;
			params.Recurrence = {
				...form.jobDateTime.Recurrence,
				EndsOn : new Date(EndsOn.getTime() - (EndsOn.getTimezoneOffset() * 60000)).toISOString().slice(0, -1),
			};
		}

		return params;
	}

	getEstimate = (form, callbackMethod = undefined) => {
		this.setState({ loading : true });

		const params = this.buildJobRequestData(form);

		InvoiceEstimatesService.getEstimateByData({ data : params })
			.then(({ data }) => {
				this.setState({ estimate : data || {}, loading : false }, () => {
					if (callbackMethod) callbackMethod();
				});
			})
			.catch(({ response : { data } }) => {
				this.setState({ loading : false });
				// Check for errors related to tax calculation (AvaTax)
				if (data.Message.includes(' tax')) {
					utils.notify({
						type    : 'error',
						message : 'Provided address is invalid. Please update and try again.',
						timeOut : 2000,
					});
					this.slideToBusinessInfo();
				} else {
					utils.notify({
						type    : 'error',
						message : data.Message || 'Error loading estimate',
					});
				}
			});
	}

	incrementStep = () => {
		const {
			currentStep, steps, form, requestSubmitted,
		} = this.state;
		if (currentStep <= steps.length) {
			this.setState({ currentStep : currentStep + 1 }, async () => {
				const { currentStep : newStep } = this.state;
				ReactGA.pageview(`RKConnect-Step-${newStep}`);
				if ((newStep <= steps.length) || (newStep > steps.length && requestSubmitted)) {
					await this.slider.slickGoTo(newStep - 1);
					if (window.innerWidth < 768) {
						const progressBar = document.getElementById('progress-bar');
						window.scrollTo({
							left     : progressBar.offsetLeft,
							top      : progressBar.offsetTop - 10,
							behavior : 'smooth',
						});
					}
				}
			});
		}

		if (currentStep === steps.length - 1) {
			this.getEstimate(form);
		}
	}

	decrementStep = () => {
		const { currentStep } = this.state;
		if (currentStep > 1) {
			this.setState((prevState) => ({ currentStep : prevState.currentStep - 1 }), () => {
				const { currentStep : newStep } = this.state;
				ReactGA.pageview(`RKConnect-Step-${newStep}`);
				this.slider.slickGoTo(newStep - 1);
				if (window.innerWidth < 768) {
					const progressBar = document.getElementById('progress-bar');
					window.scrollTo({
						left     : progressBar.offsetLeft,
						top      : progressBar.offsetTop - 10,
						behavior : 'smooth',
					});
				}
			});
		}
	}

	markRequestSubmitted = () => {
		this.setState({ requestSubmitted : true }, () => {
			this.incrementStep();
		});
	}

	changeEventType = (value, text) => {
		this.setState((prevState) => ({
			...prevState,
			form : {
				...prevState.form,
				JobEventTypeId : value,
				JobEventType   : text,
			},
		}));
	}

	setJobDateTime = (values) => {
		const {
			StartDateTime,
			EndDateTime,
			JobDetails,
			Recurrence,
		} = values;

		const repeatTypeName = Recurrence ? Object.values(RECURRENCE_FREQUENCIES)
			.find(({ value }) => (value === parseInt(Recurrence.RepeatType, 10))).label : '';

		this.setState((prevState) => ({
			...prevState,
			form : {
				...prevState.form,
				jobDateTime : {
					StartDateTime,
					EndDateTime,
					JobDetails,
					Recurrence,
				},
				repeatTypeName,
			},
		}));
	}

	setBusinessInfo = (values) => {
		const {
			LocationName,
			LocationTypeId,
			StreetAddress,
			City,
			StateId,
			ZipCode,
		} = values;

		const { user } = this.props;

		const { USStates } = this.state;
		const stateName = USStates.find(({ value }) => (value === parseInt(StateId, 10))).label;

		this.setState((prevState) => ({
			...prevState,
			form : {
				...prevState.form,
				business : {
					LocationName : !user.Id ? LocationName : user.Organization.Name,
					LocationTypeId,
					StreetAddress,
					City,
					StateId,
					ZipCode,
				},
				stateName,
			},
		}));
	}

	setContactInfo = (values) => {
		const {
			FirstName,
			LastName,
			Email,
			MobilePhone,
			Password,
		} = values;
		this.setState((prevState) => ({
			...prevState,
			form : {
				...prevState.form,
				contact : {
					FirstName,
					LastName,
					Email,
					MobilePhone,
					Password,
				},
			},
		}));
	}

	setSignUpToken = (signUpToken) => {
		this.setState({ signUpToken });
	}

	slideToJobDateTime = () => {
		this.setState({ currentStep : 2 }, () => {
			ReactGA.pageview('RKConnect-Revise-JobDateTime');
			this.slider.slickGoTo(1);
			if (window.innerWidth < 768) {
				const progressBar = document.getElementById('progress-bar');
				window.scrollTo({
					left     : progressBar.offsetLeft,
					top      : progressBar.offsetTop - 10,
					behavior : 'smooth',
				});
			}
		});
	}

	slideToBusinessInfo = () => {
		this.setState({ currentStep : 3 }, () => {
			ReactGA.pageview('RKConnect-Revise-BusinessInfo');
			this.slider.slickGoTo(2);
			if (window.innerWidth < 768) {
				const progressBar = document.getElementById('progress-bar');
				window.scrollTo({
					left     : progressBar.offsetLeft,
					top      : progressBar.offsetTop - 10,
					behavior : 'smooth',
				});
			}
		});
	}

	slideToEstimate = () => {
		this.setState({ currentStep : 5 }, () => {
			const { form } = this.state;
			ReactGA.pageview('RKConnect-Recalculate-Estimate');
			this.slider.slickGoTo(4);
			this.getEstimate(form);
			if (window.innerWidth < 768) {
				const progressBar = document.getElementById('progress-bar');
				window.scrollTo({
					left     : progressBar.offsetLeft,
					top      : progressBar.offsetTop - 10,
					behavior : 'smooth',
				});
			}
		});
	}

	setAccountCreated = (accountCreated) => {
		this.setState({ accountCreated });
	}

	saveJobRequest = () => {
		const { form } = this.state;

		this.setState({ loading : true });

		const params = this.buildJobRequestData(form);

		ReactGA.event({
			category : 'RKConnect',
			action 	 : 'Job Requested',
		});

		JobService.saveClientJobRequest(params)
			.then(() => {
				this.setState({ loading : false });
				// Move to confirmation screen automatically
				this.markRequestSubmitted();
			})
			.catch(({ response : { data } }) => {
				this.setState({ loading : false });
				utils.notify({
					type    : 'error',
					message : data.Message || 'Error saving job',
				});
			});
	}

	render() {
		const {
			currentStep, steps, accountCreated, form, USStates, estimate, loading, signUpToken,
		} = this.state;

		const {
			history, user, receiveUser, login,
		} = this.props;

		return (
			<div id="marketplace">
				<PublicMenu hideSignIn />
				<div id="marketplace-content">
					<div className="container text-center">
						<div className="row">
							<h1 id="page-header">Hire Off-Duty Officers Direct</h1>
							<ProgressBar currentStep={currentStep} isLoggedIn={this.isLoggedIn} steps={steps} />
						</div>
					</div>
					<div className="container">
						<div className="row">
							<div id="step-text" className="col-sm-4 col-md-offset-1 clearfix">
								<div className={`animated fadeIn${currentStep !== 1 ? ' hidden' : ''}`}>
									<h4 className="step-header">Get Rolling With Your Security Needs</h4>
									RollKall connects your business with law enforcement agencies and officers for
									off-duty security. We simplify the hiring and payment of law enforcement officers
									and their departments for both small local businesses and large national brands.
									<h5 className="step-point-header">Tell Us Your Security Needs</h5>
									Tell us your security officer needs and when you will need an officer.
									<h5 className="step-point-header">Verify Business</h5>
									Let us know the job address and who will be the officer contact.
									<h5 className="step-point-header">Review &amp; Pay Estimate</h5>
									RollKall will give you an estimate for the job. Review and pay.
								</div>
								<div className={`animated fadeIn${currentStep !== 2 ? ' hidden' : ''}`}>
									<div className="labeled-icon">
										<img
											id="marketplace-officer-logo"
											src="/images/officer.png"
											alt="officer"
										/>
										<h4>Every officer arrives fully armed and in uniform.</h4>
									</div>
									<img
										className="officer-picture hidden-xs"
										src="/images/law-enforcement-officers.png"
										alt="officer"
									/>
									<h5 className="step-header">
										In order to better guarantee the fulfillment of your off-duty request, please provide us
										with a four day advance window.
									</h5>
								</div>
								<div
									className={`animated fadeIn ${currentStep !== 3 ? 'hidden' : ''}`}
								>
									<div className="labeled-icon">
										<img
											id="marketplace-location-office-logo"
											src="/images/office.png"
											alt="Location-form-office"
										/>
										<h4>
											We work with 1,400 law enforcement agencies across 25 states
										</h4>
									</div>
									<img
										className="officer-picture hidden-xs"
										src="/images/law-enforcement-agencies.png"
										alt="officer"
									/>
								</div>
								<If condition={!user.Id}>
									<div className={`animated fadeIn${currentStep !== 4 ? ' hidden' : ''}`}>
										<div id="availability-info">
											<h4>Off-Duty may not be available in all areas</h4>
											In order to better serve you, please fill out your contact information so we may provide
											you an estimate or direct you to the best avenue to help you with your off-duty needs.
										</div>
										<div className="off-duty-info">
											<img src={Rewind} alt="Off-Duty Hours icon" className="rewind-icon" />
											<h4>
												1.3 million jobs in off-duty hours have been worked via RollKall
											</h4>
										</div>
										<img
											className="officer-picture no-top-margin hidden-xs"
											src="/images/coordinators.png"
											alt="officer"
										/>
									</div>
								</If>
								<div
									className={`animated fadeIn ${currentStep !== 5 ? 'hidden' : ''}`}
								>
									<div className="labeled-icon">
										<i id="marketplace-search-job-logo" className="rkf rkf-search-job" />
										<h4>
											180,000 jobs have been scheduled through the RollKall platform
										</h4>
									</div>
									<img
										className="officer-picture hidden-xs"
										src="/images/Officer-in-badge.png"
										alt="officer"
									/>
								</div>
							</div>
							<div id="step-form" className="col-md-6 col-sm-8">
								<Slider
									ref={(slider) => { this.slider = slider; }}
									arrows={false}
									infinite={false}
									pauseOnHover={false}
									className="form-slider"
									swipe={false} // TODO: call the usual increment/decrement step, with any API calls or validations needed
									accessibility={false}
								>
									<SecurityType
										JobEventTypeId={form.JobEventTypeId}
										changeEventType={this.changeEventType}
										toNextStep={this.incrementStep}
									/>
									<JobDateTime
										toNextStep={this.incrementStep}
										toPreviousStep={this.decrementStep}
										setJobDateTime={this.setJobDateTime}
										JobEventType={form.JobEventType}
										accountCreated={accountCreated}
										slideToEstimate={this.slideToEstimate}
									/>
									<BusinessInfo
										toPrevStep={this.decrementStep}
										toNextStep={this.incrementStep}
										setBusinessInfo={this.setBusinessInfo}
										JobEventType={form.JobEventType}
										accountCreated={accountCreated}
										USStates={USStates}
										signUpToken={signUpToken}
										slideToEstimate={this.slideToEstimate}
										user={user}
										receiveUser={receiveUser}
									/>
									<If condition={steps.includes('Contact')}>
										<ContactInfo
											JobEventType={form.JobEventType}
											accountCreated={accountCreated}
											business={form.business}
											signUpToken={signUpToken}
											toPreviousStep={this.decrementStep}
											setContactInfo={this.setContactInfo}
											setAccountCreated={this.setAccountCreated}
											setSignUpToken={this.setSignUpToken}
											toNextStep={this.incrementStep}
											history={history}
											login={login}
											receiveUser={receiveUser}
										/>
									</If>
									<EstimatePreview
										toPrevStep={this.decrementStep}
										form={form}
										estimate={estimate}
										onFinish={this.saveJobRequest}
										slideToJobDateTime={this.slideToJobDateTime}
										slideToBusinessInfo={this.slideToBusinessInfo}
										signUpToken={signUpToken}
									/>
									<Confirmation JobEventType={form.JobEventType} />
								</Slider>
								<Loader active={loading} className="marketplace-loader" />
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ({
	app : {
		user,
	},
}) => ({
	user,
});

const mapDispatchToProps = (dispatch) => ({
	login       : bindActionCreators(appActions, dispatch).login,
	receiveUser : bindActionCreators(appActions, dispatch).receiveUser,
});

MarketPlace.propTypes = {
	history     : PropTypes.object.isRequired,
	user        : PropTypes.object,
	login       : PropTypes.func.isRequired,
	receiveUser : PropTypes.func.isRequired,
	location    : PropTypes.object,
};

MarketPlace.defaultProps = {
	user     : {},
	location : {},
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketPlace);
